import { Controller } from "@hotwired/stimulus"

// Google Maps autocomplete for Canadian addresses
export default class extends Controller {
  static targets = [
    "addressInput",
    "cityField",
    "provinceField",
    "postalCodeField",
    "manualFields",
    "mailingAddressField"
  ]

  static values = {
    apiKey: String
  }

  connect() {
    // Wait for Google Maps API to load
    this.initializeAutocomplete()
  }

  initializeAutocomplete() {
    if (typeof google === "undefined") {
      // API not loaded yet, try again in 100ms
      setTimeout(() => this.initializeAutocomplete(), 100)
      return
    }

    // Initialize autocomplete with Canadian addresses only
    this.autocomplete = new google.maps.places.Autocomplete(
      this.addressInputTarget,
      {
        componentRestrictions: { country: "ca" },
        fields: ["address_components", "formatted_address"],
        types: ["address"]
      }
    )

    // Listen for place selection
    this.autocomplete.addListener("place_changed", () => {
      this.handlePlaceChanged()
    })
  }

  handlePlaceChanged() {
    const place = this.autocomplete.getPlace()

    if (!place.address_components) {
      return
    }

    // Extract address components
    let streetNumber = ""
    let route = ""
    let city = ""
    let province = ""
    let postalCode = ""

    place.address_components.forEach((component) => {
      const type = component.types[0]

      switch (type) {
        case "street_number":
          streetNumber = component.long_name
          break
        case "route":
          route = component.long_name
          break
        case "locality":
          city = component.long_name
          break
        case "administrative_area_level_1":
          province = component.short_name
          break
        case "postal_code":
          postalCode = component.long_name
          break
      }
    })

    // Update form fields
    this.addressInputTarget.value = `${streetNumber} ${route}`.trim()
    this.cityFieldTarget.value = city
    this.provinceFieldTarget.value = province
    this.postalCodeFieldTarget.value = postalCode

    // Validation feedback
    if (!city || !province || !postalCode) {
      this.showManualFields()
    }
  }

  handleInput(event) {
    // Clear hidden fields when user types (they'll be re-populated on selection)
    if (this.hasCityFieldTarget) this.cityFieldTarget.value = ""
    if (this.hasProvinceFieldTarget) this.provinceFieldTarget.value = ""
    if (this.hasPostalCodeFieldTarget) this.postalCodeFieldTarget.value = ""
  }

  showManualFields() {
    if (this.hasManualFieldsTarget) {
      this.manualFieldsTarget.classList.remove("hidden")
    }
  }

  toggleMailingAddress(event) {
    if (this.hasMailingAddressFieldTarget) {
      if (event.target.checked) {
        this.mailingAddressFieldTarget.classList.remove("hidden")
      } else {
        this.mailingAddressFieldTarget.classList.add("hidden")
      }
    }
  }
}
